import React from "react";
import ReactDOM from "react-dom/client";
import AppRoutes from "./AppRoutes";
// import reportWebVitals from "./reportWebVitals";
import "./App.css";
// import "react-quill/dist/quill.snow.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppRoutes />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
